import { useHistory, useLocation } from "react-router-dom";
import { useState } from "react";

import {
  Grid,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  IconButton,
  Typography,
  Select,
  Button,
  AppBar,
  Toolbar,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import { Logout } from "@mui/icons-material";

import { Us, Br } from "react-flags-select";

import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { TRANSLATIONS_PT } from "../../translate/pt";
import { TRANSLATIONS_EN } from "../../translate/en";

import { useAuthState } from "react-firebase-hooks/auth";

import { auth, logout } from "../../services/firebase";
import logoStakeMobile from "../../imagens/logoStakeMobile.png";
import logo_stake from "../../imagens/logo_stake.png";

import metaverso from "../../imagens/metaverso.png";

import useWindowDimensions from "../../hooks/useWindowDimensions";

import "./NavigationStaking.styles.css";
import { accountsCallBack } from "../../services/accountsCallBack";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: {
        translation: TRANSLATIONS_PT,
      },
      en: {
        translation: TRANSLATIONS_EN,
      },
    },
  });

export const NavigationStaking = () => {
  const { t, i18n } = useTranslation();
  const [anchorElNav, setAnchorElNav] = useState(null);
  const open = Boolean(anchorElNav);
  const { width } = useWindowDimensions();
  const [user, loading] = useAuthState(auth);
  const history = useHistory();
  const location = useLocation();

  const handleClickUser = (e) => {
    setAnchorElNav(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorElNav(null);
  };

  const callLogout = () => {
    logout();
    history.push("/");
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleOnclickPT = () => {
    i18n.changeLanguage("pt");
  };

  const handleOnclickEN = () => {
    i18n.changeLanguage("en");
  };

  const pages = [
    { title: `${t("ecosystem")}`, target: "", href: "/" },
    { title: `${t("exchange")}`, target: "_self", href: "/exchange" },
    // {
    //   title: `${t("exchange")}`,
    //   target: "_self",
    //   href: "https:///exchange.kahsh.com",
    // },
    // { title: `${t("Kahsh Labs")}`, target: "_self", href: "/kahshpay" },
    {
      title: `${t("kahshStore")}`,
      target: "_blank",
      href: "https://www.kahshstore.com.br/",
    },
    { title: `${t("kahshPay")}`, target: "_self", href: "/kahshpay" },
    {
      title: `${t("foundation")}`,
      target: "_self",
      href: "/foundation",
    },
    { title: `${t("stake")}`, target: "_self", href: "/staking" },
    { title: `${t("extract")}`, target: "_self", href: "/extrato" },
    {
      title: `${t("news")}`,
      target: "_blank",
      href: "/https://kahsh.medium.com/",
    },
  ];

  return (
    <>
      {width >= 1200 ? ( // largura de 1200 acima (TV/Monitor grande...)
        <>
          <Grid container p="1vw 2.5vw" className="kahshIoNavigationContainer">
            {/* ====== BOTÕES DE NAVEGAÇÃO WEB ====== */}
            {/* ====== LOGO WEB ====== */}
            <Grid
              item
              className="containerNavigationLogoStakingStakingStakingStakingStaking"
            >
              <a href="/">
                <img src={logo_stake} alt="" />
              </a>
            </Grid>

            <Grid className="kahshIoNavigationBtns">
              <a href="/">
                <Typography>{t("ecosystem")}</Typography>
              </a>
              <a href="/exchange" target="_self">
                <Typography>{t("exchange")}</Typography>
              </a>
              {/* <a href="https:///exchange.kahsh.com" target="_self">
                <Typography>{t("exchange")}</Typography>
              </a> */}
              <a href="https://www.kahshstore.com.br" target="_blank">
                <Typography>{t("kahshStore")}</Typography>
              </a>
              <a href="/kahshpay" target="_self">
                <Typography>{t("kahshPay")}</Typography>
              </a>
              <a href="/foundation" target="_self">
                <Typography>{t("foundation")}</Typography>
              </a>

              {/*  select com submenu */}
              <Typography>{t("Smart Kahsh")}</Typography>
              <Grid className="stakeSelectContainer">
                <Select id="stakeSelect">
                  <MenuItem>
                    <a href="/staking" target="_self">
                      <Typography pb={1}>{t("stake")}</Typography>
                    </a>
                  </MenuItem>
                  <MenuItem>
                    <a onClick={() => (window.location.href = "/extrato")}>
                      <Typography pt={1}>{t("extract")}</Typography>
                    </a>
                  </MenuItem>
                </Select>
              </Grid>
              <a href="/https://kahsh.medium.com/" target="_blank">
                <Typography>{t("news")}</Typography>
              </a>
            </Grid>

            {/* ====== BOTÕES DE CADASTRO / LOGIN / USER WEB E SELECT COM TRANSLATE WEB ====== */}
            <Grid display="flex">
              {/* ====== SELECT COM TRANSLATE WEB ====== */}
              <Grid className="kahshIoNavigationSelectTranslate">
                <Select
                  className="select"
                  labelId="translate"
                  id="translate"
                  defaultValue={
                    i18n.language.substring(0, 2) == "pt" ? "PTB" : "EN"
                  }
                >
                  <MenuItem
                    onClick={handleOnclickPT}
                    className="translate"
                    value="PTB"
                  >
                    <Br fontSize="2.5rem" />
                    <Typography
                      pl={1}
                      fontSize="1.3rem"
                      fontFamily="Montserrat"
                      fontWeight={700}
                      color="#838383"
                    >
                      Português (BR)
                    </Typography>
                  </MenuItem>

                  <MenuItem
                    onClick={handleOnclickEN}
                    className="translate"
                    value="EN"
                  >
                    <Us fontSize="2.5rem" />
                    <Typography
                      pl={1}
                      fontSize="1.3rem"
                      fontFamily="Montserrat"
                      fontWeight={700}
                      color="#838383"
                    >
                      English (US)
                    </Typography>
                  </MenuItem>
                </Select>
              </Grid>

              <Grid className="kahshIoNavigationyWrapperAuthentication">
                {!user && !loading ? (
                  <>
                    <Grid className="kahshIoNavigationMetaversoStaking">
                      <Button>
                        <a href="https://kahsh.land/#/" target="_blank">
                          <img src={metaverso} alt="" />
                        </a>
                      </Button>
                    </Grid>

                    <Grid className="kahshIoNavigationCadastrarStaking">
                      <Button onClick={() => accountsCallBack("register")}>
                        {t("register")}
                      </Button>
                    </Grid>

                    <Grid className="kahshIoNavigationEnter">
                      <Button onClick={() => accountsCallBack("login")}>
                        {t("enter")}
                      </Button>
                    </Grid>
                  </>
                ) : (
                  <>
                    {/* ====== AVATAR / USER ====== */}
                    {user ? (
                      <Grid className="kahshIoNavigationyWrapperAuthentication">
                        <Grid className="kahshIoNavigationMetaversoStaking">
                          <Button>
                            <a href="https://kahsh.land/#/" target="_blank">
                              <img src={metaverso} alt="" />
                            </a>
                          </Button>
                        </Grid>
                        <IconButton
                          onClick={handleClickUser}
                          size="small"
                          sx={{ ml: 2 }}
                          aria-controls={open ? "account-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                        >
                          <Avatar sx={{ width: 32, height: 32 }}>
                            {user.email[0].toUpperCase()}
                          </Avatar>
                        </IconButton>
                      </Grid>
                    ) : null}
                  </>
                )}
              </Grid>
            </Grid>
            {/* menu dentro do avatar */}
            <Menu
              anchorEl={anchorElNav}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              className="newMenu"
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              {/* dentro do menu escondido */}

              {/* botão de sair */}
              <MenuItem onClick={() => callLogout()}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                {t("logoutAccount")}
              </MenuItem>
            </Menu>
          </Grid>
        </>
      ) : width < 1200 && width >= 1024 ? ( // largura abaixo de 1200 até 1024(mac mini)
        <>
          <Grid container p="1vw 2.5vw" className="kahshIoNavigationContainer">
            {/* ====== BOTÕES DE NAVEGAÇÃO WEB ====== */}
            {/* ====== LOGO WEB ====== */}
            <Grid
              item
              className="containerNavigationLogoStakingStakingStakingStakingStaking"
            >
              <a href="/">
                <img src={logoStakeMobile} alt="" />
              </a>
            </Grid>

            <Grid className="kahshIoNavigationBtns">
              <a href="/">
                <Typography>{t("ecosystem")}</Typography>
              </a>
              <a href="/exchange" target="_self">
                <Typography>{t("exchange")}</Typography>
              </a>
              {/* <a href="https:///exchange.kahsh.com" target="_self">
                <Typography>{t("exchange")}</Typography>
              </a> */}
              {/* <a href="/" target="_self">
                <Typography>{t("Kahsh Labs")}</Typography>
              </a> */}
              <a href="https://www.kahshstore.com.br" target="_blank">
                <Typography>{t("kahshStore")}</Typography>
              </a>
              <a href="/kahshpay" target="_self">
                <Typography>{t("kahshPay")}</Typography>
              </a>
              <a href="/foundation" target="_self">
                <Typography>{t("foundation")}</Typography>
              </a>

              {/*  select com submenu */}
              <Typography>{t("Smart Kahsh")}</Typography>
              <Grid className="stakeSelectContainer">
                <Select id="stakeSelect">
                  <MenuItem>
                    <a href="/staking" target="_self">
                      <Typography pb={1}>{t("stake")}</Typography>
                    </a>
                  </MenuItem>
                  <MenuItem>
                    <a onClick={() => (window.location.href = "/extrato")}>
                      <Typography pt={1}>{t("extract")}</Typography>
                    </a>
                  </MenuItem>
                </Select>
              </Grid>
              <a href="/https://kahsh.medium.com/" target="_blank">
                <Typography>{t("news")}</Typography>
              </a>
            </Grid>

            {/* ====== BOTÕES DE CADASTRO / LOGIN / USER WEB E SELECT COM TRANSLATE WEB ====== */}
            <Grid display="flex">
              {/* ====== SELECT COM TRANSLATE WEB ====== */}
              <Grid className="kahshIoNavigationSelectTranslate">
                <Select
                  className="select"
                  labelId="translate"
                  id="translate"
                  defaultValue={
                    i18n.language.substring(0, 2) == "pt" ? "PTB" : "EN"
                  }
                >
                  <MenuItem
                    onClick={handleOnclickPT}
                    className="translate"
                    value="PTB"
                  >
                    <Br fontSize="2.5rem" />
                    <Typography
                      pl={1}
                      fontSize="1.3rem"
                      fontFamily="Montserrat"
                      fontWeight={700}
                      color="#838383"
                    >
                      Português (BR)
                    </Typography>
                  </MenuItem>

                  <MenuItem
                    onClick={handleOnclickEN}
                    className="translate"
                    value="EN"
                  >
                    <Us fontSize="2.5rem" />
                    <Typography
                      pl={1}
                      fontSize="1.3rem"
                      fontFamily="Montserrat"
                      fontWeight={700}
                      color="#838383"
                    >
                      English (US)
                    </Typography>
                  </MenuItem>
                </Select>
              </Grid>

              <Grid className="kahshIoNavigationyWrapperAuthentication">
                {!user && !loading ? (
                  <>
                    <Grid className="kahshIoNavigationMetaversoStaking">
                      <Button>
                        <a
                          rel="noreferrer"
                          href="https://kahsh.land/#/"
                          target="_blank"
                        >
                          <img src={metaverso} alt="" />
                        </a>
                      </Button>
                    </Grid>

                    <Grid className="kahshIoNavigationCadastrarStaking">
                      <Button onClick={() => accountsCallBack("register")}>
                        {t("register")}
                      </Button>
                    </Grid>

                    <Grid className="kahshIoNavigationEnter">
                      <Button onClick={() => accountsCallBack("login")}>
                        {t("enter")}
                      </Button>
                    </Grid>
                  </>
                ) : (
                  <>
                    {/* ====== AVATAR / USER ====== */}
                    {user ? (
                      <Grid className="kahshIoNavigationyWrapperAuthentication">
                        <Grid className="kahshIoNavigationMetaversoStaking">
                          <Button>
                            <a href="https://kahsh.land/#/" target="_blank">
                              <img src={metaverso} alt="" />
                            </a>
                          </Button>
                        </Grid>
                        <IconButton
                          onClick={handleClickUser}
                          size="small"
                          sx={{ ml: 2 }}
                          aria-controls={open ? "account-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                        >
                          <Avatar sx={{ width: 32, height: 32 }}>
                            {user.email[0].toUpperCase()}
                          </Avatar>
                        </IconButton>
                      </Grid>
                    ) : null}
                  </>
                )}
              </Grid>
            </Grid>
            {/* menu dentro do avatar */}
            <Menu
              anchorEl={anchorElNav}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              className="newMenu"
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              {/* dentro do menu escondido */}

              {/* Link para extrato */}
              {/* {user && (
              <Typography pb={1} pl={2} className="userEmail">
                {user.email}
              </Typography>
            )} */}

              {/* <Divider /> */}

              {/* configuração do usuário */}
              {/* <MenuItem>
              <ListItemIcon>
                <Settings fontSize="small" />
              </ListItemIcon>
              {t("manageKahshAccount")}
            </MenuItem> */}

              {/* botão de sair */}
              <MenuItem onClick={() => callLogout()}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                {t("logoutAccount")}
              </MenuItem>
            </Menu>
          </Grid>
        </>
      ) : (
        // largura abaixo de 1200 até 1024(mac mini)
        <>
          <Grid className="kahshIoNavigationContainerMobile">
            <AppBar position="fixed" elevation={0}>
              <Toolbar disableGutters className="toolbar">
                <Grid
                  item
                  width="100%"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {/* logo */}
                  <Grid ml={3} item>
                    <a href="#page-top">
                      <img
                        className="logoMobile"
                        src={logoStakeMobile}
                        alt=""
                      />
                    </a>
                  </Grid>

                  {/* botão hamburguer */}
                  <Grid item pr={4} className="containerBtnHamburguer">
                    <IconButton
                      size="large"
                      aria-label="account of current user"
                      aria-controls="menu-appbar"
                      aria-haspopup="true"
                      onClick={handleOpenNavMenu}
                    >
                      <MenuIcon />
                    </IconButton>
                  </Grid>

                  {/* botão */}
                  <Menu
                    anchorEl={anchorElNav}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    open={Boolean(anchorElNav)}
                    onClose={handleCloseNavMenu}
                  >
                    {/* menu dentro do avatar */}
                    <Menu
                      anchorEl={anchorElNav}
                      id="account-menu"
                      open={open}
                      onClose={handleClose}
                      onClick={handleClose}
                      className="newMenu"
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          overflow: "visible",
                          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                          mt: 1.5,
                          "& .MuiAvatar-root": {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                          },
                          "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                          },
                        },
                      }}
                      transformOrigin={{ horizontal: "right", vertical: "top" }}
                      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    >
                      {/* dentro do menu escondido */}
                      {/*  select do translate + user */}
                      <Grid
                        item
                        px={3}
                        display="flex"
                        flexDirection="column"
                        className="containerNavigationUser"
                      >
                        {/* select do translate versão web */}
                        <Grid
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          flexDirection="column"
                          pb={2}
                        >
                          {/* botões de cadastro e enter ou user caso já esteja logado versão mobile */}
                          <Grid pt={1}>
                            {!user && !loading ? (
                              <>
                                <Grid
                                  mb={1}
                                  className="kahshIoNavigationCadastrarMobile"
                                >
                                  <Button
                                    onClick={() => accountsCallBack("register")}
                                  >
                                    {t("register")}
                                  </Button>
                                </Grid>

                                <Grid
                                  mb={1}
                                  className="kahshIoNavigationEnterMobile"
                                >
                                  <Button
                                    onClick={() => accountsCallBack("login")}
                                  >
                                    {t("enter")}
                                  </Button>
                                </Grid>

                                <Grid className="kahshIoNavigationMetaversoMobile">
                                  <Button>
                                    <a
                                      rel="noreferrer"
                                      href="https://kahsh.land/#/"
                                      target="_blank"
                                    >
                                      <img src={metaverso} alt="" />
                                    </a>
                                  </Button>
                                </Grid>
                              </>
                            ) : (
                              <>
                                {/* ====== AVATAR / USER ====== */}
                                {user ? (
                                  <Grid
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                  >
                                    <IconButton
                                      onClick={handleClickUser}
                                      size="small"
                                      sx={{ ml: 2 }}
                                      aria-controls={
                                        open ? "account-menu" : undefined
                                      }
                                      aria-haspopup="true"
                                      aria-expanded={open ? "true" : undefined}
                                    >
                                      <Avatar sx={{ width: 32, height: 32 }}>
                                        {user.email[0].toUpperCase()}
                                      </Avatar>
                                    </IconButton>
                                  </Grid>
                                ) : null}
                              </>
                            )}
                          </Grid>

                          {/* ====== SELECT COM TRANSLATE MOBILE ====== */}
                          <Grid className="kahshIoNavigationSelectTranslate">
                            <Select
                              className="select"
                              labelId="translate"
                              id="translate"
                              defaultValue={
                                i18n.language.substring(0, 2) == "pt"
                                  ? "PTB"
                                  : "EN"
                              }
                              // className="selectA"
                            >
                              <MenuItem
                                onClick={handleOnclickPT}
                                className="translate"
                                value="PTB"
                              >
                                <Br fontSize="2.5rem" />
                                <Typography
                                  pl={1}
                                  fontSize="1.3rem"
                                  fontFamily="Montserrat"
                                  fontWeight={700}
                                  color="#838383"
                                >
                                  Português (BR)
                                </Typography>
                              </MenuItem>

                              <MenuItem
                                onClick={handleOnclickEN}
                                className="translate"
                                value="EN"
                              >
                                <Us fontSize="2.5rem" />
                                <Typography
                                  pl={1}
                                  fontSize="1.3rem"
                                  fontFamily="Montserrat"
                                  fontWeight={700}
                                  color="#838383"
                                >
                                  English (US)
                                </Typography>
                              </MenuItem>
                            </Select>

                            {user && (
                              <Grid className="kahshIoNavigationMetaversoStaking">
                                <Button>
                                  <a
                                    href="https://kahsh.land/#/"
                                    target="_blank"
                                  >
                                    <img src={metaverso} alt="" />
                                  </a>
                                </Button>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>

                      {/* Box com o for com os menus e o extrato */}
                      <Grid
                        pb={2}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        flexDirection="column"
                      >
                        {pages.map((page) => (
                          <MenuItem
                            key={page.title}
                            target={page.target}
                            href={page.href}
                          >
                            <Button
                              key={page.title}
                              target={page.target}
                              href={page.href}
                              className="kahshIoNavigationBtnsMobile"
                            >
                              {page.title}
                            </Button>
                          </MenuItem>
                        ))}
                      </Grid>

                      {/* botão de sair   */}
                      {!user && !loading ? null : (
                        <Grid
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          className="sairButton"
                        >
                          <Button onClick={() => callLogout()} size="medium">
                            {t("logoutAccount")}
                          </Button>
                        </Grid>
                      )}
                    </Menu>
                  </Menu>
                </Grid>
              </Toolbar>
            </AppBar>
          </Grid>
        </>
      )}
    </>
  );
};
